import { isEqual } from 'lodash'

export const validateTableHeaderWidth = (value: string) => {
  //
  // empty value evaluates to true to allow empty field
  // to pass validation. Use 'required' validation
  // in addition to this one to validate for presence
  // of value.
  //
  if (isEqual(value, '')) {
    return true || ''
  }
  const regex = /\d+?.?\d+(px|%)/
  return regex.test(value) || tableHeaderWidthHint
}

export const tableHeaderWidthHint = "Pixels ('100px') or percentage ('20%')"
